export interface FileUploadProps {
  readonly accept: string;
  readonly label?: string;
  readonly onText: (text: string, fileName: string) => void;
  readonly readFile?: (file: File) => Promise<string>; // テスト注入用(既定 FileReader)
}

let uploadSeq = 0;

function defaultReadFile(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result ?? ""));
    reader.onerror = () => reject(reader.error ?? new Error("read failed"));
    reader.readAsText(file);
  });
}

// ファイル選択 + ドラッグ&ドロップのアップロード領域。読み込んだテキストを onText に渡す。
// ファイル内容はブラウザ内で処理され、サーバへは送信しない(モック)。
export function createFileUpload(props: FileUploadProps): HTMLElement {
  const readFile = props.readFile ?? defaultReadFile;
  uploadSeq += 1;
  const inputId = "file-upload-" + uploadSeq;

  const zone = document.createElement("div");
  zone.dataset["testid"] = "dropzone";
  zone.className =
    "rounded-lg border-2 border-dashed border-slate-300 p-6 text-center hover:border-shinonome-500";

  const label = document.createElement("label");
  label.htmlFor = inputId;
  label.className = "block cursor-pointer text-sm font-medium text-slate-700";
  label.textContent = (props.label ?? "ファイル") + " を選択（またはここにドラッグ&ドロップ）";

  const input = document.createElement("input");
  input.id = inputId;
  input.type = "file";
  input.accept = props.accept;
  input.className = "mt-2 block w-full text-sm text-slate-600";

  function handle(file: File | undefined): void {
    if (file === undefined) return;
    void readFile(file).then((text) => props.onText(text, file.name));
  }

  input.addEventListener("change", () => {
    handle(input.files?.[0]);
  });
  zone.addEventListener("dragover", (e) => {
    e.preventDefault();
    zone.classList.add("border-shinonome-500");
  });
  zone.addEventListener("dragleave", () => {
    zone.classList.remove("border-shinonome-500");
  });
  zone.addEventListener("drop", (e) => {
    e.preventDefault();
    zone.classList.remove("border-shinonome-500");
    const dt = (e as DragEvent).dataTransfer;
    handle(dt?.files?.[0]);
  });

  zone.append(label, input);
  return zone;
}
